export default {
    sendSearchResultsLoadedEvent: sendSearchResultsLoadedEvent,
};

function sendSearchResultsLoadedEvent(searchResultCount) {
    if (process.env.NODE_ENV === 'production' && typeof dataLayer !== 'undefined') {
        dataLayer.push({
            'event': 'searchResultsLoaded',
            'searchResultCount': searchResultCount,
        });
    }
}